import { useRouter } from 'next/router'
import { pick } from 'lodash'
import { format } from 'date-fns'
import { useSetRecoilState } from 'recoil'

import postVenueRequest from '../api/postVenueRequest'
import { formResponse } from '../store/venueRequest'

export interface CachedRequest {
  eventUuid: string
  requestUuid: string
  dateArrival: string
  dateDeparture: string
  groupSize: string | number
}

const useSubmitVenueRequest = (slug: string, isFirstRequest = false) => {
  const setResponse = useSetRecoilState(formResponse)
  const { locale } = useRouter()

  // @ts-ignore
  return async (data) => {
    const formattedData = {
      venueSlug: slug,
      locale,
      ...data,
      dateArrival: format(new Date(data.dateArrival), 'yyyy-MM-dd'),
      dateDeparture: format(new Date(data.dateDeparture), 'yyyy-MM-dd'),
      roomsSingle: data.roomsSingle,
      roomsDouble: data.roomsDouble,
    }

    if ('termsConditionsAccepted' in data) {
      formattedData.privacyPolicyAccepted = data.termsConditionsAccepted
    }

    const resp = await postVenueRequest(formattedData, isFirstRequest)

    if (resp?.data?.status === 'success') {
      const prevSlugRequests = localStorage.getItem(slug) || '[]'
      const newSlugRequest: CachedRequest = {
        requestUuid: resp.data.data.request_uuid,
        eventUuid: resp.data.data.event_uuid,
        ...pick(data, ['dateArrival', 'dateDeparture', 'groupSize']),
      }

      localStorage.setItem(slug, JSON.stringify([newSlugRequest, ...JSON.parse(prevSlugRequests)]))

      setResponse({
        requestUuid: resp.data.data.request_uuid,
        moreVenuesUrl: resp.data.data.more_venues_url,
        similarVenues: resp.data.data.similar_venues,
      })
    }

    return resp
  }
}

export default useSubmitVenueRequest
